import { Logo } from "./Logo";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "../lib/constants";
import { Mail } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 border-t border-white/10 bg-wyd-bg" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <div className="text-3xl" data-testid="footer-logo"><Logo /></div>
        <p className="mt-4 text-sm text-wyd-muted max-w-xs leading-relaxed">
          Eventi curati, locali autentici e atmosfere che ti fanno stare bene. La tua serata a Milano, ovunque tu sia.
        </p>
      </div>
      <div>
        <div className="overline text-wyd-accent mb-4">Esplora</div>
        <ul className="space-y-2 text-sm text-wyd-muted">
          <li><Link to="/" className="hover:text-white transition-colors duration-200">Eventi</Link></li>
          <li><Link to="/mappa" className="hover:text-white transition-colors duration-200">Mappa</Link></li>
          <li><Link to="/perche-wyd" className="hover:text-white transition-colors duration-200">Perché WYD</Link></li>
          <li><Link to="/proponi" className="hover:text-white transition-colors duration-200">Proponi Evento</Link></li>
        </ul>
      </div>
      <div>
        <div className="overline text-wyd-accent mb-4">Legale</div>
        <ul className="space-y-2 text-sm text-wyd-muted">
          <li><Link to="/privacy" className="hover:text-white transition-colors duration-200">Privacy Policy</Link></li>
          <li><Link to="/termini" className="hover:text-white transition-colors duration-200">Termini di Servizio</Link></li>
          <li><Link to="/chi-siamo" className="hover:text-white transition-colors duration-200">Chi Siamo</Link></li>
        </ul>
      </div>
      <div>
        <div className="overline text-wyd-accent mb-4">Contatti</div>
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-sm text-wyd-muted hover:text-wyd-accent flex items-center gap-2 transition-colors duration-200 break-all">
          <Mail size={15} /> {CONTACT_EMAIL}
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-wyd-muted">
      © {new Date().getFullYear()} WYD Milano · Fatto con passione per la notte milanese
    </div>
  </footer>
);
